module.exports = __webpack_public_path__ + "img/finger.215f46c5.png";